import { useQuery } from "@tanstack/react-query";
import React from "react";
import { Link } from "react-router-dom";
import { fetchAllPosts } from "../blog.utils";
import Breadcrumb from "./Breadcrumb";

const BlogList: React.FC = () => {
  const query = useQuery({
    queryKey: ["posts"],
    queryFn: fetchAllPosts,
  });

  return (
    <div className="container mx-auto px-4 py-8">
      <Breadcrumb
        paths={[
          { name: "Home", path: "/" },
          { name: "Blog", path: "/blog" },
        ]}
      />
      <h1 className="text-3xl font-bold mb-4">Recent Posts</h1>
      {(() => {
        switch (query.status) {
          case "pending":
            return <p>Loading...</p>;

          case "error":
            return <p>Error: {query.error.message}</p>;

          case "success":
            return query.data.map((post, index) => (
              <div key={index} className="mb-4">
                <h2 className="text-2xl font-semibold">
                  <Link
                    className="text-blue-500 hover:underline"
                    to={`/blog/${post.slug}`}
                  >
                    {post.metadata.title}
                  </Link>
                </h2>
                <p className="text-sm text-gray-500">{post.metadata.date}</p>
                <p>{post.metadata.description}</p>
              </div>
            ));
        }
      })()}
    </div>
  );
};

export default BlogList;
